import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'time.page',
  templateUrl: './time.page.html',
  styleUrls: ['./time.page.scss']
})
export class TimePage implements OnInit 
{
  constructor() { }

  ngOnInit(): void 
  {
    
  }

}
